import { render, staticRenderFns } from "./fenxiangbi.vue?vue&type=template&id=76af1194&scoped=true&"
import script from "./fenxiangbi.vue?vue&type=script&lang=js&"
export * from "./fenxiangbi.vue?vue&type=script&lang=js&"
import style0 from "./fenxiangbi.vue?vue&type=style&index=0&id=76af1194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76af1194",
  null
  
)

export default component.exports